"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_id_serialiser_1 = require("./../../session/session-id-serialiser");
/**
 * Serialiser for {@link GetSessionPropertiesRequestSerialiser}
 */
var GetSessionPropertiesRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(GetSessionPropertiesRequestSerialiserClass, _super);
    function GetSessionPropertiesRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link GetSessionPropertiesRequestSerialiser} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link GetSessionPropertiesRequest} to be written
     */
    GetSessionPropertiesRequestSerialiserClass.prototype.write = function (bos, value) {
        // tslint:disable-next-line:strict-type-predicates
        if (value.sessionID === undefined || value.sessionID === null) {
            throw new Error('session ID is null or undefined');
        }
        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
        // tslint:disable-next-line:strict-type-predicates
        if (value.propertyKeys !== undefined && value.propertyKeys !== null) {
            Codec.writeCollection(bos, value.propertyKeys, Codec.writeString);
        }
        else {
            Codec.writeCollection(bos, [], Codec.writeString);
        }
    };
    return GetSessionPropertiesRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GetSessionPropertiesRequestSerialiserClass = GetSessionPropertiesRequestSerialiserClass;
/**
 * The {@link GetSessionPropertiesRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GetSessionPropertiesRequestSerialiser = new GetSessionPropertiesRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/get-session-properties-request-serialiser.js
// module id = 1247
// module chunks = 1